import(/* webpackMode: "eager" */ "/tmp/repo/client/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/tmp/repo/client/src/components/game/card/hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/repo/client/src/components/game/detail/goaltender-comparison.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/repo/client/src/components/game/detail/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/repo/client/src/components/game/detail/players-to-watch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/repo/client/src/components/game/detail/recent-games.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/repo/client/src/components/game/detail/starting-pitchers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/repo/client/src/components/game/detail/starting-quarterbacks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/repo/client/src/components/game/detail/stat-comparison.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/repo/client/src/components/game/detail/top-leader-stats.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/repo/client/src/components/game/odds/cell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/repo/client/src/components/game/performance-chart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/repo/client/src/components/global/featured-picks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/repo/client/src/components/global/latest-injuries.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/repo/client/src/components/global/starting-lineup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/repo/client/src/components/global/top-pickers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/repo/client/src/components/global/top-sportsbooks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/repo/client/src/components/pick/activity.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/repo/client/src/components/pick/discussion-board.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/repo/client/src/components/primitives/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GameRoomProvider"] */ "/tmp/repo/client/src/utils/providers/game-room.tsx");
